<template>
  <section class="blocks" ref="blocks" data-menucolor="black">
    <component v-for="(block, k) in data" :key="k" class="block" :is="block.type + '_block'" :data="block[block.type]"></component>
  </section>
</template>

<script>

import ButtonBlock from './button'
import FocusBlock from './focus'
import GalleryBlock from './gallery'
import GridBlock from './grid'
import ImageBlock from './image'
import QuoteBlock from './quote'
import TextBlock from './text'
import VideoBlock from './video'

export default {
  name: 'blocks',
  components: {
    button_block: ButtonBlock,
    focus_block: FocusBlock,
    gallery_block: GalleryBlock,
    grid_block: GridBlock,
    image_block: ImageBlock,
    quote_block: QuoteBlock,
    text_block: TextBlock,
    video_block: VideoBlock
  },
  props: {
    data: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>
